import { Globals } from "../CoreApp/Globals";

export function killHoverPanel() {
  var wsMgr = Globals._wsMgr;
  var forceClose = false;
  var canvasPanel = wsMgr.fCanvasPanel;
  var parent = canvasPanel;
  if (parent == null) return;
  if (parent.fActiveHover == false || forceClose) {
    const hadHighlight = canvasPanel.GetHighlightCache().length > 0;
    if (!hadHighlight && !parent.fInteractPanel) return;

    canvasPanel.ClearHighlightCache();
    if (parent.fInteractPanel) {
      wsMgr.RemovePanel(parent.fInteractPanel);
      parent.fInteractPanel = null;
    }
    wsMgr.PrepRenderWS();
    wsMgr.RenderWS();
  }
}
